import { useCallback, useState } from 'react';
import api from '../utils/api';

const usePayment = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	const run = useCallback(async (fn) => {
		setLoading(true);
		setError('');
		try {
			return await fn();
		} catch (err) {
			const message = err.response?.data?.msg || err.response?.data?.message || err.message || 'Payment request failed.';
			setError(message);
			throw err;
		} finally {
			setLoading(false);
		}
	}, []);

	const fetchPaymentStatus = useCallback(
		(eventId) =>
			run(async () => {
				const res = await api.get(`/payments/event/${eventId}`);
				return res.data;
			}),
		[run]
	);

	const initializePayment = useCallback(
		(eventId, payload = {}) =>
			run(async () => {
				const res = await api.post('/payments/initialize', { eventId, ...payload });
				return res.data;
			}),
		[run]
	);

	const generatePaymentLink = useCallback(
		(eventId, payload = {}) =>
			run(async () => {
				const res = await api.post('/payments/generate-link', { eventId, ...payload });
				return res.data;
			}),
		[run]
	);

	const verifyPayment = useCallback(
		(reference) =>
			run(async () => {
				const res = await api.get(`/payments/verify/${reference}`);
				return res.data;
			}),
		[run]
	);

	const getPaymentConfig = useCallback(
		() =>
			run(async () => {
				const res = await api.get('/payments/config');
				return res.data;
			}),
		[run]
	);

	return {
		loading,
		error,
		fetchPaymentStatus,
		initializePayment,
		generatePaymentLink,
		verifyPayment,
		getPaymentConfig,
		setError,
	};
};

export default usePayment;
